import React from "react";
import { ProfilePageWidget } from "@/widgets/profile";

export const ProfilePage = () => {
  return <ProfilePageWidget />;
};
